module.exports = __webpack_public_path__ + "static/fonts/iconfont.75ed1f9e.woff";